import React from "react";
import OraganizationListContainer from "../../../component/organization/organization-list/ListContainer";

function Organization() {
  return (
    <div className="page-body">
      <OraganizationListContainer />
    </div>
  );
}

export default Organization;
